<div class="lvi-content">
    <div class="avatar"
         [nSelector]="{liste: liste, item: data}">
        <i class="material-icons-outlined">schedule_send</i>
    </div>

    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="goToDetailRelance()">
                {{ data.titreMessage }}
            </a>
        </div>

        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.relances.portee'"></strong>
                {{ data.libellePortee }}
            </li>

            <li>
                <strong [translate]="'admin.bibliotheque.notifications.relances.actif'"></strong>
                    {{ data.actif ? ('global.oui' | translate) : ('global.non' | translate) }}
            </li>
        </ul>
    </div>

    <div class="lvi-actions">
        <button *ngIf="!extraOptions?.isSousAdmin" mat-icon-button (click)="deleteRelance()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>